import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useNavigate } from '../nav';
import { VE_BANK_ASSETS } from '../lib/brand';
import { VeeMascot } from '../components/VeeMascot';
export function Splash() {
  const navigate = useNavigate();
  const reduced = useReducedMotion();
  const rise = (delay: number) => reduced ? {} : {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.6,
      delay,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
    }
  };
  return <main className="relative flex h-full w-full flex-col overflow-hidden bg-[#061827] text-white" data-id="element-679" data-mp="3k2l10pct5zsb">
      {/* Layered depth field, kept behind all content. */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-680" data-mp="3ouul3or8s5mo">
        <div className="absolute -right-24 -top-16 h-72 w-72 rounded-full bg-brand-cobalt/35 blur-3xl" data-id="element-681" data-mp="2rcunoij031x9" />
        <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-brand-purple/35 blur-3xl" data-id="element-682" data-mp="2wbpdi4fdxqqv" />
        <img src={VE_BANK_ASSETS.flowRibbon} alt="" className="absolute -left-1/4 top-1/3 w-[150%] max-w-none opacity-25" data-id="element-683" data-mp="1hcdwp57mies8" />
      </div>

      <div className="relative z-10 flex h-full flex-col px-6 pb-9 pt-16" data-id="element-684" data-mp="17mc7ga3jaqbq">
        <motion.header {...rise(0)} className="flex items-center justify-between" data-id="element-685" data-mp="12oaorqa0st0s">
          <span className="inline-flex rounded-2xl bg-white px-4 py-2.5" data-id="element-686" data-mp="12m6l99g19w11">
            <img src={VE_BANK_ASSETS.wordmark} alt="VE Bank" className="h-6 w-auto" data-id="element-687" data-mp="ynqv4wono7je" />
          </span>
          <span className="flex items-center gap-2 rounded-full border border-white/15 px-3 py-1.5 text-[9px] font-extrabold tracking-[.14em] text-blue-100" data-id="element-688" data-mp="tm1gl7285bqk">
            <span aria-hidden="true" className="vee-status h-1.5 w-1.5 rounded-full bg-brand-electric" data-id="element-689" data-mp="jpyhka2o5t7u" />
            VEE READY
          </span>
        </motion.header>

        <section className="my-auto" data-id="element-690" data-mp="2e36dy66amcvl">
          <motion.p {...rise(0.08)} className="text-[10px] font-extrabold uppercase tracking-[.24em] text-blue-200" data-id="element-691" data-mp="2e496sjn6epe5">
            A clearer kind of banking
          </motion.p>
          <motion.h1 {...rise(0.16)} className="mt-5 text-[44px] font-extrabold leading-[.94] tracking-[-.065em]" data-id="element-692" data-mp="h58u4h8rb6b5">
            Everything you need.
            <br data-id="element-693" data-mp="2hns6qnmbd4t" />
            <span className="text-blue-300" data-id="element-694" data-mp="2dzvxjqsgcme">Nothing in your way.</span>
          </motion.h1>

          <motion.div {...rise(0.24)} className="relative mt-10 overflow-hidden rounded-[30px] border border-white/20 bg-white/[.05] p-5 backdrop-blur-sm" data-id="element-695" data-mp="7cuqfiy4bpmc">
            <div className="flex items-center gap-4" data-id="element-696" data-mp="102tg9gk4zqs2">
              <span className={`relative shrink-0 ${reduced ? '' : 'float-slow'}`} data-id="element-697" data-mp="m4ldgs0f5v8z">
                <VeeMascot size={80} state="speaking" decorative data-id="element-698" data-mp="q4vwb59b8g59" />
              </span>
              <div className="min-w-0" data-id="element-699" data-mp="36u2i5kwdwpu6">
                <p className="text-sm font-extrabold" data-id="element-700" data-mp="36t9guzg72sjf">Meet Vee</p>
                <p className="mt-1 text-xs leading-relaxed text-blue-100" data-id="element-701" data-mp="3aveavzak1r6l">
                  Ask a question, get a clear answer, and see a prepared draft you control.
                </p>
              </div>
            </div>
          </motion.div>
        </section>

        <motion.footer {...rise(0.32)} className="mt-auto" data-id="element-702" data-mp="2yf4sbm9wk9m7">
          <button type="button" onClick={() => navigate('/login')} className="flex min-h-[56px] w-full items-center justify-between rounded-2xl bg-white px-5 text-sm font-extrabold text-brand-navy" data-id="element-703" data-mp="3d99m41g8xfw8">
            Enter VE Bank <span aria-hidden="true" className="text-xl" data-id="element-704" data-mp="2fmkg7gifaj53">↗</span>
          </button>
          <p className="mt-4 text-center text-[11px] font-semibold text-slate-400" data-id="element-705" data-mp="2fkg3qa6gkbt7">Secure access · Clear control</p>
        </motion.footer>
      </div>
    </main>;
}